import React, { Fragment, Component } from "react";
import PieChart from "./pieChart";
import { connect } from "react-redux";
import CalendarEvents from "./calendar";
import Transactions from "./transactions";
import BlankBill from "../bill/blankbill";
import { bindActionCreators } from "redux";
import MainTemplate from "../mainTemplate";
import { withTranslation } from "react-i18next";
import CreditLine from "../creditLine/creditLine";
import { getEmptyBills } from "../../../Redux/reducer/credit-line";
import { getAllowedCompanies } from "../../../Redux/reducer/cifCross";
import * as CreditLineActions from "../../../Redux/actions/credit-line";
import PendingTasks from "./pendingTasks";

import { ReactTitle } from "react-meta-tags";

import Card from "canvas-core-react/lib/Card";
import { getRoles } from "../../../Redux/reducer/session";
import { moduleAction } from "../../utils/functions";
import { EXECUTE, MOD_TERM_EXTENSION } from "../../../permissions";
import Disclaimer from "../../shared/Disclaimer/Disclaimer";

export class Dashboard extends Component {
  componentWillUnmount() {
    this.props.actions.clearEmptyBills();
  }

  render() {
    const { t, roles } = this.props;
    const termExtensionPermissions = moduleAction(
      roles,
      MOD_TERM_EXTENSION,
      EXECUTE
    );

    return (
      <MainTemplate className="wrapper-dashboard">
        <ReactTitle title={`${t("dashboard.meta.title")} - ${t("appName")}`} />
        {/* <div className="flex-element"> */}
        <Disclaimer containerClass={"full-width"}>
          <p className="one-line">{t("disclaimer.text")}</p>
        </Disclaimer>
        <CreditLine dashboard={true} />
        {/* <CreditLine dashboard={true} /> */}
        {/* </div> */}
        <div className="components">
          {this.props.emptyBills === true ? (
            <BlankBill />
          ) : (
            <Fragment>
              <Transactions className="col-7" />
              <Card className="col-5">
                <PieChart />
                <hr className="mb-5" />
                <CalendarEvents />
                {termExtensionPermissions && (
                  <>
                    <hr className="my-5" />
                    <PendingTasks />
                  </>
                )}
              </Card>
            </Fragment>
          )}
        </div>
      </MainTemplate>
    );
  }
}

export const mapStateToProps = (state) => ({
  emptyBills: getEmptyBills(state),
  allowedCompanies: getAllowedCompanies(state),
  roles: getRoles(state),
});

export const mapDispatch = (dispatch) => {
  return {
    actions: bindActionCreators(CreditLineActions, dispatch),
  };
};

export default connect(
  mapStateToProps,
  mapDispatch
)(withTranslation()(Dashboard));
